<template>
    <div>
        <Breadcrumbs main="Admin" submain="" title="Dashboard" />
        <!-- Container-fluid starts-->
        <div class="container-fluid"> 
            <div class="row">
                <div class="col-sm-12">
                    <px-card>
                        <div slot="with-padding">
                            <h5 style="width: 100%; text-align: left;">Welcome to QuickCV Admin Panel!</h5>
                            <p class="mt-2 main-title text-right">Subscription</p>
                            <div>
                                <div class="d-flex flex-column flex-md-row">
                                    <div class="col-md-4">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <router-link to="/subscription/user/list?page=1&perPage=25">
                                                <div class="title">User
                                                    <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count">20</div>
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="col-md-4 margin-y-axis">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <router-link to="/subscription/payment-initiated/list?page=1&perPage=25">
                                                <div class="title">Payment Initiated
                                                    <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count">55</div>
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <router-link to="/subscription/activated/list?page=1&perPage=25">
                                                <div class="title">Paid & Activated
                                                    <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count">12</div>
                                            </router-link>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                            <div class="mt-4">
                                <p class="mt-5 main-title">System</p>
                                <div class="d-flex flex-column flex-md-row">
                                    <div class="col-md-3">
                                        <router-link to="/system/payment-log?page=1&perPage=25">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Payment
                                                       <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count">25</div>
                                            </div>
                                        </div>
                                        </router-link>
                                    </div>
                                    <div class="col-md-3 margin-y-axis">
                                        <router-link to="/system/package">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Package
                                                    <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count">32</div>
                                            </div>
                                        </div>
                                        </router-link>
                                    </div>
                                    <div class="col-md-3 margin-botton">
                                        <router-link to="/system/coin-feature">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Coin Feature
                                                    <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count">07</div>
                                            </div>
                                        </div>
                                        </router-link>
                                    </div>
                                    <div class="col-md-3">
                                        <router-link to="/system/coupon">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Coupon
                                                    <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count">12</div>
                                            </div>
                                        </div>
                                    </router-link>
                                    </div>
                                </div>

                                <p class="mt-5 main-title text-right">Operation</p>
                                <div class="d-flex flex-column flex-md-row">
                                    <div class="col-md-4">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">CV Tracking Label</div>
                                                <div class="count">88</div>
                                                <div style="padding-top: 8px; border-bottom: 2px solid #fc9d3f;"></div>
                                                <router-link to="/operation/cv-tracking-label">
                                                    <div style="text-align: center; font-size: medium; padding-top: 8px; cursor: pointer;">View</div>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 margin-y-axis">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Digital Skill</div>
                                                <div class="count">78</div>
                                                <div style="padding-top: 8px; border-bottom: 2px solid #fc9d3f;"></div>
                                                <router-link to="/operation/digital-skill">
                                                    <div style="text-align: center; font-size: medium; padding-top: 8px; cursor: pointer;">View</div>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Language</div>
                                                <div class="count">54</div>
                                                <div style="padding-top: 8px; border-bottom: 2px solid #fc9d3f;"></div>
                                                <router-link to="/operation/language">
                                                    <div style="text-align: center; font-size: medium; padding-top: 8px; cursor: pointer;">View</div>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- <div v-else>
                                <loader/>
                            </div>  -->
                        </div>
                    </px-card>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
    
<script>
    import { mapState } from 'vuex';
    import loader from '../loader/loader.vue';

    export default {
        components: {
            loader
        },
    
        computed: {
            ...mapState({
                count_list: state => state.dashboard.dashboard_count,
                loading:state => state.dashboard.dashboardCountLoading,
                error:state => state.dashboard.dashboardCountError,
            })
        },
    
        mounted() {
            this.$store.dispatch("dashboard/fetchDashboardCount")
        }
    };
</script>

<style scoped>
.margin-y-axis {
    margin-top: 16px;
    margin-bottom: 16px;
}

.margin-botton {
    margin-bottom: 16px;
}

.border-class {
    border-radius: 0.375rem;
}

.title {
    font-size: large; 
    font-weight: 500; 
    color: #fc9d3f;
}

.count {
    text-align: end; 
    font-size: xx-large; 
    font-weight: 500; 
    padding-right: 28px;
}

.main-title {
    font-size: x-large; 
    font-weight: 500;
}

@media (max-width: 1480px) {
    .main-title {
        font-size: large; 
        font-weight: 500;
    }
}

@media (max-width: 768px) {
    .count {
       padding-right: 12px;
    }
}

@media (min-width: 768px) {
    .margin-y-axis {
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .margin-botton {
        margin-bottom: 0px;
    }
}
</style>
    